
export enum LookerResultFormatCd {
	CSV = 'csv'}

